@if (fareFamiliesWithMappedBenefits().length > 0) {
  <div class="relative" data-testid="table-container">
    <fin-scroll-handle-container #scrollContainer [elements]="tableHeaders()">
      <table class="align-left">
        <caption class="is-vishidden">
          {{
            'ticketSelection.compareBenefits' | finLocalization
          }}
        </caption>
        <tr>
          @for (
            fareFamily of fareFamiliesWithMappedBenefits();
            track fareFamily.fareFamilyCode;
            let first = $first, last = $last
          ) {
            <th
              #tableHeader
              scope="col"
              class="nordic-blue-50-bg surface-secondary fare-family-table-header ps-medium-x ps-xsmall-y border-left border-top"
              [ngClass]="{
                'rounded-top-left-large': first && !last,
                'border-right': last,
                'rounded-top-right-large': last && !first,
                'rounded-top-large': last && first,
              }"
            >
              <div class="font-body-1 nordic-blue-900-text text-icon-primary font-body-medium" data-testid="brand-name">
                {{ fareFamily.brandName }}
              </div>
            </th>
          }
        </tr>
        @for (benefitKey of benefitKeys(); track benefitKey; let lastRow = $last, isOdd = $odd) {
          <tr data-testid="benefit-row">
            @for (
              fareFamily of fareFamiliesWithMappedBenefits();
              track fareFamily.fareFamilyCode;
              let firstCell = $first, lastCell = $last
            ) {
              @if (fareFamily.benefits[benefitKey]) {
                <td
                  class="ps-medium-x ps-xsmall-y border-left"
                  [ngClass]="{
                    'nordic-blue-50-bg surface-secondary': isOdd,
                    'border-bottom': lastRow,
                    'border-right': lastCell,
                    'rounded-bottom-large': lastRow && firstCell && lastCell,
                    'rounded-bottom-left-large': lastRow && firstCell && !lastCell,
                    'rounded-bottom-right-large': lastRow && lastCell && !firstCell,
                  }"
                >
                  <div class="flex flex--row flex--top">
                    <div class="flex-1">
                      <div
                        class="nordic-blue-900-text text-icon-primary bold-type font-body-2 benefitLabel font-body-small-bold"
                        data-testid="benefit-label"
                        [class.heather-700-text]="
                          showKoreaNotification() && (benefitKey === 'rebook' || benefitKey === 'cancel')
                        "
                      >
                        {{ fareFamily.benefits[benefitKey]?.label }}
                      </div>
                      <div
                        class="nordic-blue-900-text text-icon-primary regular-type font-body-2 font-body-small"
                        data-testid="benefit-value"
                      >
                        {{ fareFamily.benefits[benefitKey]?.value }}
                      </div>
                    </div>
                    @if (showIcons()) {
                      <div class="flex--nogrow">
                        @if (fareFamily.benefits[benefitKey]?.isPositive) {
                          <fcom-icon
                            class="icon-medium heather-700-text text-icon-primary"
                            [dataTestId]="'benefit-icon-' + SvgLibraryIcon.CHECKMARK"
                            [name]="SvgLibraryIcon.CHECKMARK"
                          />
                        }
                        @if (fareFamily.benefits[benefitKey] && !fareFamily.benefits[benefitKey].isPositive) {
                          <fcom-icon
                            class="icon-medium"
                            [dataTestId]="'benefit-icon-' + SvgLibraryIcon.CLOSE_DELETE"
                            [name]="SvgLibraryIcon.CLOSE_DELETE"
                          />
                        }
                      </div>
                    }
                  </div>
                  @if (fareFamily.benefits[benefitKey]?.children) {
                    @for (childBenefit of fareFamily.benefits[benefitKey].children; track $index) {
                      <div class="flex flex--row flex--top pr-small-l">
                        <div class="flex-1">
                          <div
                            class="nordic-blue-900-text text-icon-primary bold-type font-body-2 benefitLabel font-body-small-bold"
                            data-testid="benefit-label"
                            [class.heather-700-text]="
                              showKoreaNotification() && (benefitKey === 'rebook' || benefitKey === 'cancel')
                            "
                          >
                            {{ childBenefit.label }}
                          </div>
                          <div
                            class="nordic-blue-900-text text-icon-primary regular-type font-body-2 font-body-small"
                            data-testid="benefit-value"
                          >
                            {{ childBenefit.value }}
                          </div>
                        </div>
                        @if (showIcons()) {
                          <div class="flex--nogrow">
                            @if (childBenefit.isPositive) {
                              <fcom-icon
                                class="icon-medium heather-700-text text-icon-primary"
                                [dataTestId]="'benefit-icon-' + SvgLibraryIcon.CHECKMARK"
                                [name]="SvgLibraryIcon.CHECKMARK"
                              />
                            }
                            @if (!childBenefit.isPositive) {
                              <fcom-icon
                                class="icon-medium"
                                [dataTestId]="'benefit-icon-' + SvgLibraryIcon.CLOSE_DELETE"
                                [name]="SvgLibraryIcon.CLOSE_DELETE"
                              />
                            }
                          </div>
                        }
                      </div>
                    }
                  }
                </td>
              }
            }
          </tr>
        }
      </table>
    </fin-scroll-handle-container>
  </div>
}
